<template>
  <div class="multimedias">
    <div class="multimedias-actions">
      <selection
        :id="`multimedias-category`"
        :options="categories"
        :selected="category"
        :placeholder="'Toutes les catégories'"
        @option="$emit('filter', { event: $event })"
      />
    </div>

    <div class="multimedias-list">
      <template
        v-if="multimedias.length > 0"
      >
        <multimedia
          v-for="(multimedia, index) in multimedias"
          :key="`${multimedia.id}-${index}`"
          :multimedia="multimedia"
        />
      </template>
    </div>

    <loader v-if="loading" />
  </div>
</template>

<script>
import Selection from '@/components/components/Selection.vue';
import Multimedia from '@/components/modules/Multimedia.vue';
import Loader from '@/components/components/Loader.vue';

export default {
  components: {
    Loader,
    Selection,
    Multimedia
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    multimedias: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    category: {
      type: Object,
      default: () => {}
    },
  }
};
</script>

<style lang="scss" scoped>

  .multimedias {
    margin-top: 20px;

    &-list {
      margin-top: 30px;
    }
  }
</style>
